import Home from '../client/pages/me/pages/home/index';
import Vip from '../client/pages/me/pages/vip/index';
import Settings from '../client/pages/me/pages/setting/index.jsx';
import AddressBook from '../client/pages/me/pages/address-book/index.jsx';
import CreditCards from '../client/pages/me/pages/credit-cards/index.jsx';
import ChangePassword from '../client/pages/me/pages/change-password/index.jsx';
import ChangeEmail from '../client/pages/me/pages/change-email/index.jsx';
import Credits from "../client/pages/me/pages/credits/index";
import SettingPolicy from '../client/pages/me/pages/setting/components/setting-policy'
import EditProfile from '../client/pages/me/pages/edit-profile'
import SetName from '../client/pages/me/pages/edit-profile/set-name'
import SetNickName from '../client/pages/me/pages/edit-profile/set-nick-name'
import SetBio from '../client/pages/me/pages/edit-profile/set-bio'
import MyPreference from '../client/pages/me/pages/edit-profile/my-preference'
import MyMeasurements from '../client/pages/me/pages/edit-profile/my-measurements'
import Notification from '../client/pages/me/pages/notification'
import NotificationTicket from '../client/pages/me/pages/notification/notification-ticket'
import NotificationOrders from '../client/pages/me/pages/notification/notification-orders'
import NotificationNews from '../client/pages/me/pages/notification/notification-news'
import CouponsPage from '../client/pages/me/pages/coupons';
import WalletPage from '../client/pages/me/pages/wallet';
import PointsHistory from '../client/pages/me/pages/points-history/index';
import PointsHistoryAll from '../client/pages/me/pages/points-history/all';
import PointsHistoryRecived from '../client/pages/me/pages/points-history/recived';
import PointsHistoryUsed from '../client/pages/me/pages/points-history/used';
import RedeemCouponsPage from '../client/pages/me/pages/coupons/redeem-coupon';
import SurveyPage from '../client/pages/me/pages/survey';
import PointsHistoryExpired from '../client/pages/me/pages/points-history/expired';
import WishList from "../client/pages/me/pages/wishlist/index";
import PointsGuide from '../client/pages/me/pages/points-guide';
import ConfirmSuccess from '../client/pages/me/pages/confirm-success';
import ReferFriend from '../client/pages/me/pages/refer-friend';
import MakeSuggestionPage from '../client/pages/me/pages/make-suggestion';
import MainOrder from '../client/pages/me/pages/order/list/index';
import OrderListAll from "../client/pages/me/pages/order/list/all";
import OrderDetail from '../client/pages/me/pages/order/detail/normal/index';
import OrderReturnDetail from '../client/pages/me/pages/order/detail/return/index';
import OrderListUnpaid from '../client/pages/me/pages/order/list/unpaid';
import OrderListProcessing from '../client/pages/me/pages/order/list/processing';
import OrderListShipped from '../client/pages/me/pages/order/list/shipped';
import OrderListConfirmed from '../client/pages/me/pages/order/list/confirm';
import OrderListReturn from '../client/pages/me/pages/order/list/return';
import OrderReview from '../client/pages/me/pages/order/review';
import OrderFullPackageTrack from '../client/pages/me/pages/order/track/full-package/index';
import OrderSubPackageTrack from '../client/pages/me/pages/order/track/sub-package/index';
import ReturnLogistics from '../client/pages/me/pages/order/return-logistics';
import OrderListHistory from '../client/pages/me/pages/order/list/history-order/index';
import SupportPage from '../client/pages/support';
import ContactUs from '../client/pages/support/pages/contact-us';
import Questions from '../client/pages/support/pages/questions';
import FaqSearch from '../client/pages/support/pages/faq-search';
import TicketList from '../client/pages/support/pages/ticket-list';
import TicketDetail from '../client/pages/support/pages/ticket-detail';
import OrderListPage from '../client/pages/support/pages/order-list-page';

export const BASE_USER = "/user";

export default [
    {
        path: "/user",
        exact: true,
        component: Home,
        page: 'me',
        cn_page: '个人中心',
        title: {
            en: 'Profile'
        },
        description: {
            en: 'Profile'
        }
    },
    {
        path: "/user/vip",
        exact: true,
        component: Vip,
        page: 'vip',
        cn_page: 'Vip Page',
        title: {
            en: 'User Vip'
        },
        description: {
            en: 'User Vip'
        }
    },
    {
        path: "/user/settings",
        exact: true,
        component: Settings,
        page: 'settings',
        cn_page: '设置',
        title: {
            en: 'Settings'
        },
        description: {
            en: 'Settings'
        }
    },
    {
        path: "/user/address-book",
        exact: true,
        component: AddressBook,
        page: 'address book',
        cn_page: '地址簿',
        title: {
            en: 'Address Book'
        },
    },
    {
        path: "/user/address-book",
        exact: true,
        component: AddressBook,
        page: 'address book',
        cn_page: '地址簿',
        title: {
            en: 'Address Book'
        },
        description: {
            en: 'Address Book'
        }
    },
    {
        path: "/user/credit-cards",
        exact: true,
        component: CreditCards,
        page: 'credits cards',
        cn_page: '绑卡信息',
        title: {
            en: 'Credit Cards'
        },
        description: {
            en: 'Credit Cards'
        }
    },
    {
        path: "/user/change-password",
        exact: true,
        component: ChangePassword,
        page: 'change password',
        cn_page: '修改密码',
        title: {
            en: 'Change Password'
        },
        description: {
            en: 'Change Password'
        }
    },
    {
        path: "/user/change-email",
        exact: true,
        component: ChangeEmail,
        page: 'change email',
        cn_page: '修改邮箱',
        title: {
            en: 'Change Email'
        },
        description: {
            en: 'Change Email'
        }
    },
    {
        path: "/user/credits",
        exact: true,
        component: Credits,
        page: 'credits',
        cn_page: '积分',
        title: {
            en: 'My Points'
        },
        description: {
            en: 'My Points'
        }
    },
    {
        path: "/user/setting-policy",
        exact: true,
        component: SettingPolicy,
        page: 'setting policy',
        cn_page: '设置政策',
        title: {
            en: 'Setting Policy'
        },
        description: {
            en: 'Setting Policy'
        }
    },
    {
        path: '/user/edit-profile',
        exact: true,
        component: EditProfile,
        page: 'edit profile',
        cn_page: '编辑个人信息',
        title: {
            en: 'Edit Profile'
        },
        description: {
            en: 'Edit Profile'
        }
    },
    {
        path: '/user/set-name',
        exact: true,
        component: SetName,
        page: 'set name',
        cn_page: '编辑姓名',
        title: {
            en: 'Name'
        },
        description: {
            en: 'Name'
        }
    },
    {
        path: '/user/set-nick-name',
        exact: true,
        component: SetNickName,
        page: 'set nick name',
        cn_page: '编辑昵称',
        title: {
            en: 'Nickname'
        },
        description: {
            en: 'Nickname'
        }
    },
    {
        path: '/user/set-bio',
        exact: true,
        component: SetBio,
        page: 'set bio',
        cn_page: '编辑介绍',
        title: {
            en: 'Bio'
        },
        description: {
            en: 'Bio'
        }
    },
    {
        path: '/user/my-preference',
        exact: true,
        component: MyPreference,
        page: 'my preference',
        cn_page: '个人喜好',
        title: {
            en: 'My Preference'
        },
        description: {
            en: 'My Preference'
        }
    },
    {
        path: '/user/my-measurements',
        exact: true,
        component: MyMeasurements,
        page: 'my measurements',
        cn_page: '个人尺寸',
        title: {
            en: 'My Measurements'
        },
        description: {
            en: 'My Measurements'
        }
    },
    {
        path: '/user/notification',
        exact: true,
        component: Notification,
        page: 'notification',
        cn_page: '消息通知',
        title: {
            en: 'Notification'
        },
        description: {
            en: 'Notification'
        },
    },
    {
        path: '/user/notification/ticket',
        exact: true,
        component: NotificationTicket,
        page: 'notification ticket',
        cn_page: 'ticket消息通知',
        title: {
            en: 'Notification'
        },
        description: {
            en: 'Notification'
        }
    },
    {
        path: '/user/notification/orders',
        exact: true,
        component: NotificationOrders,
        page: 'notification orders',
        cn_page: '订单消息通知',
        title: {
            en: 'Notification'
        },
        description: {
            en: 'Notification'
        }
    },
    {
        path: '/user/notification/news',
        exact: true,
        component: NotificationNews,
        page: 'notification news',
        cn_page: '新消息通知',
        title: {
            en: 'Notification'
        },
        description: {
            en: 'Notification'
        }
    },
    {
        path: '/user/coupons',
        exact: true,
        component: CouponsPage,
        page: 'coupons',
        cn_page: '优惠券',
        title: {
            en: 'Coupons'
        },
        description: {
            en: 'Coupons'
        }
    },
    {
        path: '/user/redeem-coupon',
        exact: true,
        component: RedeemCouponsPage,
        page: 'Redeem Coupons',
        cn_page: '积分兑换优惠券',
        title: {
            en: 'Redeem Coupons'
        },
        description: {
            en: 'Redeem Coupons'
        }
    },
    {
        path: '/user/wallet',
        exact: true,
        component: WalletPage,
        page: 'wallet',
        cn_page: '钱包',
        title: {
            en: 'Wallet'
        },
        description: {
            en: 'Wallet'
        }
    },
    {
        path: '/user/points-history',
        component: PointsHistory,
        page: 'me',
        cn_page: '全部历史积分',
        title: {
            en: 'PointsHistoryAll'
        },
        description: {
            en: 'PointsHistoryAll'
        },
        routes:[
            {
                path: '/user/points-history/all',
                component: PointsHistoryAll,
                page: 'me',
                cn_page: '全部历史积分记录',
                title: {
                    en: 'PointsHistoryAll'
                },
                description: {
                    en: 'PointsHistoryAll'
                }
            },
            {
                path: '/user/points-history/recived',
                component: PointsHistoryRecived,
                page: 'me',
                cn_page: '得到历史积分记录',
                title: {
                    en: 'PointsHistoryRecived'
                },
                description: {
                    en: 'PointsHistoryRecived'
                }
            },
            {
                path: '/user/points-history/used',
                component: PointsHistoryUsed,
                page: 'me',
                cn_page: '使用历史积分记录',
                title: {
                    en: 'PointsHistoryRecived'
                },
                description: {
                    en: 'PointsHistoryRecived'
                }
            },
            {
                path: '/user/points-history/expired',
                component: PointsHistoryExpired,
                page: 'me',
                cn_page: '过期历史积分记录',
                title: {
                    en: 'PointsHistoryRecived'
                },
                description: {
                    en: 'PointsHistoryRecived'
                }
            }
        ]
    },
    {
        path: '/user/survey',
        component: SurveyPage,
        page: 'survey',
        cn_page: '问卷调查',
        title: {
            en: 'Survey'
        },
        description: {
            en: 'Survey'
        }
    },
    {
        path: '/user/suggestion',
        component: MakeSuggestionPage,
        page: 'suggestion',
        cn_page: '问题反馈',
        title: {
            en: 'Suggestion'
        },
        description: {
            en: 'Suggestion'
        }
    },
    {
        path: '/user/wishlist',
        exact: true,
        component: WishList,
        page: 'me',
        cn_page: '喜欢',
        title: {
            en: 'Wishlist'
        },
        description: {
            en: 'Wishlist'
        }
    },
    {
        path: '/user/point-guide',
        exact: true,
        component: PointsGuide,
        page: 'me',
        cn_page: '积分',
        title: {
            en: 'My Points'
        },
        description: {
            en: 'My Points'
        }
    },
    {
        path: '/user/confirmSuccess*',
        exact: true,
        component: ConfirmSuccess,
        page: 'me',
        cn_page: '邮箱确认',
        title: {
            en: 'Login Protection'
        },
        description: {
            en: 'Login Protection'
        }
    },
    {
        path: '/user/share',
        exact: true,
        component: ReferFriend,
        page: 'me',
        cn_page: '分享',
        title: {
            en: 'Share'
        },
        description: {
            en: 'Share'
        }
    },
    {
        path: `${BASE_USER}/order/tracking/:orderId`,
        exact: true,
        component: OrderFullPackageTrack,
        page: 'me',
        cn_page: '物流整包发货',
        title: {
            en: 'Track Full Package'
        },
        description: {
            en: 'Track Full Package'
        }
    },
    // 兼容pc路由router
    {
        path: `${BASE_USER}/order//logistics-detail`,
        exact: true,
        component: OrderFullPackageTrack,
        page: 'me',
        cn_page: '物流整包发货',
        title: {
            en: 'Track Full Package'
        },
        description: {
            en: 'Track Full Package'
        }
    },
    {
        path: `${BASE_USER}/order/packageTracking`,
        exact: true,
        component: OrderSubPackageTrack,
        page: 'me',
        cn_page: '物流分包发货',
        title: {
            en: 'Track Sub Package'
        },
        description: {
            en: 'Track Sub Package'
        }
    },
    {
        path: `${BASE_USER}/order/detail/:orderId`,
        exact: true,
        component: OrderDetail,
        page: 'Order',
        cn_page: '订单详情',
        title: {
            en: 'Order Detail'
        },
        description: {
            en: 'Order Detail'
        }
    },
    {
        path: `${BASE_USER}/order/return-detail/:returnId`,
        exact: true,
        component: OrderReturnDetail,
        page: 'Order',
        cn_page: '退货订单详情',
        title: {
            en: 'Return Order Detail'
        },
        description: {
            en: 'Return Order Detail'
        }
    },
    {
        path: `${BASE_USER}/order/review/:orderId`,
        exact: true,
        component: OrderReview,
        page: 'Order',
        cn_page: '订单评论',
        title: {
            en: 'Order Review'
        },
        description: {
            en: 'Order Review'
        }
    },
    {
        path: `${BASE_USER}/order/return-logistics/:returnId`,
        exact: true,
        component: ReturnLogistics,
        page: 'Order',
        cn_page: '订单退货凭证',
        title: {
            en: 'Order Return Logistics'
        },
        description: {
            en: 'Order Return Logistics'
        }
    },
    {
        path: `${BASE_USER}/order/history-orders`,
        exact: true,
        component: OrderListHistory,
        page: 'Order',
        cn_page: '历史订单',
        title: {
            en: 'history orders'
        },
        description: {
            en: 'history orders'
        }
    },
    {
        path: `${BASE_USER}/order`,
        component: MainOrder,
        page: 'Order',
        cn_page: '订单',
        title: {
            en: 'Order'
        },
        description: {
            en: 'Order'
        },
        meta:{
            showHeader:true
        },
        routes:[
            {
                path: `${BASE_USER}/order/all`,
                exact: true,
                component: OrderListAll,
                page: 'me',
                cn_page: '全部订单',
                title: {
                    en: '全部订单'
                },
                description: {
                    en: '全部订单'
                },
                meta:{
                    showHeader:true
                }
            },
            {
                path: `${BASE_USER}/order/unpaid`,
                exact: true,
                component: OrderListUnpaid,
                page: 'me',
                cn_page: '未付款订单',
                title: {
                    en: 'Unpaid Order'
                },
                description: {
                    en: 'Unpaid Order'
                },
                meta:{
                    showHeader:true
                }
            },
            {
                path: `${BASE_USER}/order/processing`,
                exact: true,
                component: OrderListProcessing,
                page: 'me',
                cn_page: '仓库打包中订单',
                title: {
                    en: 'Processing Order'
                },
                description: {
                    en: 'Processing Order'
                },
                meta:{
                    showHeader:true
                }
            },
            {
                path: `${BASE_USER}/order/shipped`,
                exact: true,
                component: OrderListShipped,
                page: 'me',
                cn_page: '运输中订单',
                title: {
                    en: 'Shipped Order'
                },
                description: {
                    en: 'Shipped Order'
                },
                meta:{
                    showHeader:true,
                    slideNext:true
                }
            },
            {
                path: `${BASE_USER}/order/confirmed`,
                exact: true,
                component: OrderListConfirmed,
                page: 'me',
                cn_page: '已完成订单',
                title: {
                    en: 'Confirmed Order'
                },
                description: {
                    en: 'Confirmed Order'
                },
                meta:{
                    showHeader:true,
                    slideNext:true
                }
            },
            {
                path: `${BASE_USER}/order/return`,
                exact: true,
                component: OrderListReturn,
                page: 'me',
                cn_page: '退货订单',
                title: {
                    en: 'Return Order'
                },
                description: {
                    en: 'Return Order'
                },
                meta:{
                    showHeader:true,
                    slideNext:true
                }
            }
        ]
    },
    {
        path: `${BASE_USER}/support`,
        exact: true,
        component: SupportPage,
        page: 'me',
        cn_page: '服务支持',
        title: {
            en: 'Support'
        },
        description: {
            en: 'Support'
        },
    },
    {
        path: `${BASE_USER}/support/contact-us`,
        exact: true,
        component: ContactUs,
        page: 'me',
        cn_page: '联系我们',
        title: {
            en: 'Contact Us'
        },
        description: {
            en: 'Contact Us'
        },
    },
    {
        path: `${BASE_USER}/support/ticketvip`,
        exact: true,
        component: ContactUs,
        page: 'me',
        cn_page: '联系我们',
        title: {
            en: 'VIP-Service'
        },
        description: {
            en: 'VIP-Service'
        },
    },
    {
        path: `${BASE_USER}/support/faq`,
        exact: true,
        component: Questions,
        page: 'me',
        cn_page: '常见问题',
        title: {
            en: 'FAQ'
        },
        description: {
            en: 'FAQ'
        },
    },
    {
        path: `${BASE_USER}/support/question`,
        exact: true,
        component: FaqSearch,
        page: 'me',
        cn_page: '问题搜索结果',
        title: {
            en: 'FAQ'
        },
        description: {
            en: 'FAQ'
        },
    },
    {
        path: `${BASE_USER}/support/ticket`,
        exact: true,
        component: TicketList,
        page: 'me',
        cn_page: 'Ticket列表',
        title: {
            en: 'Ticket List'
        },
        description: {
            en: 'Ticket List'
        },
    },
    {
        path: `${BASE_USER}/support/ticket-vip`,
        exact: true,
        component: TicketList,
        page: 'me',
        cn_page: 'Ticket列表',
        title: {
            en: 'VIP-Service'
        },
        description: {
            en: 'VIP-Service'
        },
    },
    {
        path: `${BASE_USER}/faq/support-ticket`,
        exact: true,
        component: TicketDetail,
        page: 'me',
        cn_page: 'Ticket详情',
        title: {
            en: 'Ticket'
        },
        description: {
            en: 'Ticket'
        },
    },
    {
        path: `${BASE_USER}/faq/support-ticket/:ticketId`,
        exact: true,
        component: TicketDetail,
        page: 'me',
        cn_page: 'Ticket详情',
        title: {
            en: 'Ticket'
        },
        description: {
            en: 'Ticket'
        },
    },
    {
        path: `${BASE_USER}/support/order`,
        exact: true,
        component: OrderListPage,
        page: 'me',
        cn_page: 'Ticket订单列表',
        title: {
            en: 'Order List Page'
        },
        description: {
            en: 'Order List Page'
        },
    },
]